module.exports = __webpack_public_path__ + "h5/img/standard.ebdd5bd1.png";